export const ModalChangePasswordTranslationsEn = {
  changePassword: 'Change password',
  yourPassword: 'Password',
  newPassword: 'New password',
  'Enter new password': 'Enter the new password again',
  saveButton: 'Save',
};
